import Switch from "react-switch";
export const ToogleField = ({
    toggleStatus,
    plan,
    statusClass
  }) => {

return (
        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px",  }}>
            <span
                className={`px-2  rounded-lg text-sm ${statusClass}`}
                style={{ minWidth: "60px", textAlign: "center" }}
            >
                {plan.status ? "Active" : "Inactive"}
            </span>

            <Switch 
                onChange={() => toggleStatus(plan)}
                checked={plan.status}
                offColor="#ccc"
                onColor="#4CAF50"
                uncheckedIcon={false}
                checkedIcon={false}
                height={20}
                width={40}
            />
            </div>
        </td>)
  }